module.exports = __webpack_public_path__ + "assets/ic_tree02.90a93f38.svg";